/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Box, Card, Typography,
    Modal,
    CardContent,
    InputAdornment, Button, Autocomplete,
} from "@mui/material";
import { appConstants } from "utils/appConstants";
import MDButton from 'components/MDButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MDBox from 'components/MDBox';
import { CSVLink } from "react-csv";
import HelpIcon from '@mui/icons-material/Help';
import { getScreenRight } from 'utils/generic';
import { fetchQuotationReportData } from 'utils/api';
// import { getClientReport } from 'utils/superAdminApi';
import { useDispatch } from 'react-redux';
import { BTable } from 'components/BTable/BTable';
import PageTitle from 'examples/PageTitle/PageTitle';
import { showResMsg } from 'utils/generic';
import { genericMessage } from 'utils/genericMessages';
import { GridSearchIcon } from '@mui/x-data-grid';
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { useMaterialUIController } from "context";
import { fetchQuotationContacts } from 'utils/api';
import PickDate from 'components/DatePicker/DatePicker';
import { useSelector } from "react-redux";
import TimelineItem from 'components/Icon/TimelineItem';
import { formatCurrencyAUD } from 'utils/formatCurrency';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'grid',
    justifyContent: 'center'
};

let SCREEN_RIGHT;
function QuotationReport() {
    const [rows, setRows] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [tabledata, setTableData] = useState([]);
    const [showModel, setShowModel] = useState(false)
    const [resetClicked, setResetClicked] = useState(false);
    const [disableColor, setDisableColor] = useState(false);
    const dispatch = useDispatch()
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const { barColor } = getColorMappings(sidenavColor);
    const [customerReload, setCustomerReload] = useState(false)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const [contact, setContact] = useState([]);
    const [screenAccess, setScreenAccess] = useState(false);

    const [values, setValues] = React.useState({
        quotationStatus: "",
        quotationDuration: "",
        customerName: "",
        filterValues: "",
        sortingType: "",
        sortingField: "",
        page: appConstants.page,
        limit: appConstants.limit,
        customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
        customTo: new Date(),
        searchParameterList: ['quotationDate', 'quotationNumber', 'customerName', 'purchaseOrderNumber', 'validUptoDate', 'quotationStatus', 'itemName', 'itemID', 'itemPrice', 'itemQuantity', 'priceValidity', 'priceValidityValue', 'itemCategory',
            'discountType', 'discountValue', 'discountAmount', 'gst', 'gstType', 'finalAmount', 'totalAmount',
            'totalDiscountAmount', 'paymentInstruction', ' quotationDateString', 'individualItemAmount'],
        businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
    });

    //
    let currency = useSelector((state) => state.currency.currencySymbol);
    //
    const headers = [
        { label: "Quotation Number", key: "quotationNumber" },
        { label: "Quotation Date", key: "quotationDateToString" },
        { label: "Customer Name", key: "customerName" },
        { label: "Reference Number", key: "purchaseOrderNumber" },
        { label: "Quotation Status", key: "quotationStatus" },
        { label: "Valid Upto Date", key: "validUptoDate" },
        // { label: "Account", key: "itemCategory" },
        // { label: "Item Name", key: "itemName" },
        // { label: "Item Price", key: "itemPrice" },
        // { label: "Item Quantity", key: "itemQuantity" },
        // { label: "Price Validity", key: "priceValidity" },
        // { label: "Price validity Value", key: "priceValidityValue" },
        // { label: "Discount Type", key: "discountType" },
        // { label: "Discount Amount", key: "discountAmount" },
        // { label: "GST(%)", key: "gst" },
        // { label: "GST Type", key: "gstType" },
        { label: "Final Amount", key: "finalAmount" },
        { label: "Total Amount", key: "totalAmount" },
        { label: "Total Discount Amount", key: "totalDiscountAmount" },
        { label: "PaymentInstruction", key: "paymentInstruction" },
        // { label: "Individual Amount", key: "individualItemAmount" },

    ];
    useEffect(() => {
        (async () => {
            getRight();
            fetchQuotationReport();
            fetchQuotationContact();

        })()
    }, [customerReload])

    async function getRight() {
        let SCREEN_RIGHT = await getScreenRight("Quotation Reports")
        setScreenAccess(SCREEN_RIGHT === 'Full Access')
        if (SCREEN_RIGHT === "Full Access")
            setDisableColor(false)

        else setDisableColor(true)

    }

    const fetchQuotationReport = () => {

        let toDate = new Date(values.customTo);
        toDate.setUTCHours(0, 0, 0, 0);
        let fromDate = new Date(values.customFrom);
        fromDate.setUTCHours(0, 0, 0, 0);

        if (toDate < fromDate) {
            return showResMsg("To Date should not be less than from date.", 2000, false);
        }

        fetchQuotationReportData(values, (data) => {
            console.log("data===", data)
            setTotalRows(data.result.Result_Output.totalDocs)
            setRows(data.result.Result_Output.docs);
            setTableData(data.result.export);
        }, dispatch)
    };


    const handleChange = (name) => (event) => {
        setValues({ ...values, [name]: event.target.value });
    };
    const handleContactChange = (name) => (event, newValue) => {
        if (newValue) {
            setValues({ ...values, [name]: newValue.label, contactTypeId: newValue.value });
        } else {
            setValues({ ...values, [name]: '', contactTypeId: '' });
        }
    };

    const FilterData = async () => {
        fetchQuotationReport();
    };

    const ResetData = () => {
        setValues((prevValues) => ({
            ...prevValues,
            searchParameter: "",
            page: appConstants.page,
            limit: appConstants.limit,
            sortingType: "",
            sortingField: "",
            quotationStatus: "",
            quotationDuration: "",
            customerName: "",
            filterValues: "",
            searchParameterList: ['quotationDate', 'quotationNumber', 'customerName', 'purchaseOrderNumber', 'validUptoDate', 'quotationStatus', 'itemName', 'itemID', 'itemPrice', 'itemQuantity', 'priceValidity', 'priceValidityValue', 'itemCategory',
                'discountType', 'discountValue', 'discountAmount', 'gst', 'gstType', 'finalAmount', 'totalAmount',
                'totalDiscountAmount', 'paymentInstruction', ' quotationDateString', 'individualItemAmount'],
        }));
        setResetClicked(true);
    };

    useEffect(() => {
        if (resetClicked) {
            fetchQuotationReport();
            setResetClicked(false);
        }
    }, [resetClicked]);

    const handleSearchFilter = (event) => {
        setValues({ ...values, filterValues: event.target.value });
    };

    const handlePageChange = page => {
        values.page = page;
        setCustomerReload(!customerReload)
    };
    const handlePerRowsChange = async (newPerPage, page) => {
        values.page = page;
        values.limit = newPerPage
        setPerPage(newPerPage);
        setCustomerReload(!customerReload)
    };
    const handleSort = async (type, value) => {
        values.sortingType = value;
        values.sortingField = type;
        setCustomerReload(!customerReload)
    };

    function exportSwal() {
        setShowModel(false);
        showResMsg(genericMessage.dataExportedSucces, 1000, true)
    }

    const fetchQuotationContact = async () => {
        await fetchQuotationContacts(values, (data) => {
            setContact(data.Result_Output);
        }, dispatch)
    };
    const handleDateChange = (name) => (date) => {
        setValues({ ...values, [name]: new Date(date) });
    };

    const { tableBorder } = getColorMappings(sidenavColor);
    // var element = document.getElementsByTagName('fieldset');
    // useEffect(() => {
    //     for (let i = 0; i < element.length; i++) {

    //         if (darkMode) {
    //             element[i].style.borderColor = "white";
    //         } else {
    //             element[i].style.borderColor = tableBorder;
    //         }

    //     }
    // }, [showFilters])

    useEffect(() => {
        var element = document.getElementsByTagName('fieldset');
        let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
        for (let i = 0; i < element.length; i++) {

            element[i].style.borderColor = darkMode ? "white" : tableBorder;
        }

        for (let i = 0; i < labelShrink.length; i++) {
            labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
        }
    }, [darkMode,showFilters])


    useEffect(() => {
        var dropicons = document.querySelectorAll('.MuiInputBase-root');
        for (let i = 0; i < dropicons.length; i++) {
            var svgicon = dropicons[i].getElementsByTagName('svg');
            if (svgicon.length > 0) {
                if (darkMode) {
                    svgicon[0].setAttribute("style", "fill: white !important;");
                } else {
                    svgicon[0].setAttribute("style", "");
                }
            }
        }

    }, [showFilters])


    const reportCol = [
        {
            name: <p style={{ fontSize: "12px" }}>Quotation Number</p>,
            selector: row => row.quotationNumber,
            sortable: true,
            sortField: 'quotationNumber',
            minWidth: '155px'
        },
        {
            name: <p style={{ fontSize: "12px",paddingLeft:"18px" }}>Quotation Date</p>,
            selector: row => row.quotationDateToString,
            sortable: true,
            sortField: 'quotationDate',
            center: true,
            minWidth: '160px'
        },
        {
            name: <p style={{ fontSize: "12px" }}>Customer Name</p>,
            selector: row => row.customerName,
            sortable: true,
            sortField: 'customerName',
            center: true,
            minWidth: '140px'
        },
        {
            name: <p style={{ fontSize: "12px",paddingLeft:"18px" }}>Reference Number</p>,
            selector: row => row.purchaseOrderNumber,
            sortable: true,
            sortField: 'purchaseOrderNumber',
            center: true,
            minWidth: '180px',
          
        },
        {
            name: "Quotation Status",
            name: <p style={{ fontSize: "12px",paddingLeft:"18px" }}>Quotation Status</p>,
            selector: row => row.quotationStatus,
            sortable: true,
            sortField: 'quotationStatus',
            center: true,
            minWidth: '180px',
            cell: row => (
                <span
                    style={{
                        border: "1px solid black",
                        color: "black",
                        padding: "3px 3px",
                        borderRadius: "2px",
                        fontSize: "12px",
                        fontWeight: 500,
                        textTransform: "capitalize",
                        display: "inline-block",
                        minWidth: "60px",
                        textAlign: "center",
                    }}
                >
                    {row.quotationStatus || "N/A"}
                </span>
            )
        },
        {
            name: <p style={{ fontSize: "12px",paddingLeft:"18px" }}>Valid Upto Date</p>,
            selector: row => row.validUptoDate,
            sortable: true,
            sortField: 'validUptoDate',
            center: true,
            minWidth: '160px'
        },
        // {
        //     // name: "Category",
        //     name: <p style={{ fontSize: "12px" }}>Account</p>,
        //     selector: row => row.itemCategory,
        //     sortable: true,
        //     sortField: 'itemCategory',
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>Item Name</p>,
        //     selector: row => row.itemName,
        //     sortable: true,
        //     sortField: 'itemName',
        //     center: true,
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>{`Item Price (${currency})`}</p>,
        //     selector: row => row.itemPrice,
        //     sortable: true,
        //     sortField: 'itemPrice',
        //     center: true,
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>Item Quantity</p>,
        //     selector: row => row.itemQuantity,
        //     sortable: true,
        //     sortField: 'itemQuantity',
        //     center: true,
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>Discount Type</p>,
        //     selector: row => row.discountType,
        //     sortable: true,
        //     sortField: 'discountType',
        //     center: true,
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>{`Discount Amount (${currency})`}</p>,
        //     selector: row => row.discountAmount,
        //     sortable: true,
        //     sortField: 'discountAmount',
        //     center: true,
        //     minWidth: '155px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>GST(%)</p>,
        //     selector: row => row.gst,
        //     sortable: true,
        //     sortField: 'gst',
        //     center: true,
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>GST Type</p>,
        //     selector: row => row.gstType,
        //     sortable: true,
        //     sortField: 'gstType',
        //     center: true,
        //     minWidth: '140px'
        // },
        // {
        //     name: <p style={{ fontSize: "12px" }}>{`Individual Amount (${currency})`}</p>,
        //     selector: row => row.individualItemAmount,
        //     sortable: true,
        //     sortField: 'individualItemAmount',
        //     center: true,
        //     minWidth: '155px'
        // },
        {
            name: <p style={{ fontSize: "12px",paddingLeft:"30px"  }}>{`Final Amount (${currency})`}</p>,
            selector: row => formatCurrencyAUD(row.finalAmount),
            sortable: true,
            sortField: 'finalAmount',
            center: true,
            minWidth: '160px'
        },
        {
            name: <p style={{ fontSize: "12px",paddingLeft:"30px"  }}>{`Total Amount (${currency})`}</p>,
            selector: row => formatCurrencyAUD(row.totalAmount),
            sortable: true,
            sortField: 'totalAmount',
            center: true,
            minWidth: '160px'
        },
        {
            name: <p style={{ fontSize: "12px",paddingLeft:"30px"  }}>{`Total Discount Amount (${currency})`}</p>,
            selector: row => formatCurrencyAUD(row.totalDiscountAmount),
            sortable: true,
            sortField: 'totalDiscountAmount',
            center: true,
            minWidth: '220px'
        },
        {
            name: <p style={{ fontSize: "12px" }}>Payment Instruction</p>,
            selector: row => row.paymentInstruction,
            sortable: true,
            sortField: 'paymentInstruction',
            center: true,
            minWidth: '165px'
        },
        {
            name: "Actions",
            selector: row => row._id,
            center: true,
            cell: (row) => (
                <>
                    <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
                        <Grid item>
                            <Link
                                to={`/report/item/${row._id}`}
                                onClick={() => sessionStorage.setItem("reportType", "QuotationItems")} // 👈 store value
                            >
                                <TimelineItem color="success" icon="visibility" title="view" />
                            </Link>
                        </Grid>
                    </Grid>
                </>
            ),
        },
    ]

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ marginTop: '20px' }}>
                <Card color="primary">
                    <PageTitle screenName="Quotations Report" />
                    <Grid container columnSpacing={2} px={2} mt={2} mb={1} alignItems="center" display="flex" justifyContent="right">
                        {showFilters && (
                            <Grid item xs={12} md={6} lg={9.2}  >

                                {values.quotationDuration === "Custom" && (
                                    <Grid container spacing={1.6} sx={{ display: 'flex', justifyContent: 'start', paddingLeft: '10px' }}>
                                        <Grid item xs={6} lg={1.7}>
                                            <PickDate
                                                selected={new Date(values.customFrom)}
                                                onChange={handleDateChange('customFrom')}
                                                label="From"
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                            />
                                        </Grid>
                                        <Grid item xs={6} lg={1.7}>
                                            <PickDate
                                                selected={new Date(values.customTo)}
                                                onChange={handleDateChange('customTo')}
                                                label="To"
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                maxDate={new Date()}

                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        )}
                        <Grid item xs={12} md={4} spacing={2} lg={1.4} gap={0.5} >
                            <MDButton
                                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                color={"warning"}
                                fullWidth
                                onClick={() => { setShowFilters(!showFilters) }}
                                style={{ height: "38.11px" }}
                            >
                                {showFilters ? 'Hide Filters' : 'Set Filters'}

                            </MDButton>
                        </Grid>
                        <Grid item xs={12} md={4} spacing={2} lg={1.4} >

                            {screenAccess ?
                                <MDButton
                                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    style={{ backgroundColor: "#009cff", color: "#ffffff", height: "38.11px" }}
                                    fullWidth
                                    onClick={() => { setShowModel(true) }}
                                >
                                    Export
                                </MDButton>
                                :
                                <MDButton
                                    className
                                    ={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    style={{ height: "38.11px" }}
                                    color={"secondary"}
                                    fullWidth

                                >

                                    Export
                                </MDButton>
                            }
                        </Grid>
                    </Grid>
                    {showFilters && (
                        <MDBox>
                            <Grid item xs={12} >
                                <MDBox px={1} pt={1}>
                                    <Grid container columnSpacing={2} mx={.1}>
                                        <Grid item xs={12} lg={2.3}>
                                            <MDBox mb={4} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="quotationDate">Quotation Duration</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ height: "38.11px" }}
                                                        label="Quotation Duration"
                                                        value={values.quotationDuration}
                                                        onChange={handleChange('quotationDuration')}
                                                    >
                                                        {/* <MenuItem value="All"> All </MenuItem> */}
                                                        <MenuItem value="Today"> Today </MenuItem>
                                                        <MenuItem value="last7Days"> Last 7 Days  </MenuItem>
                                                        <MenuItem value="last30Days"> Last 30 Days </MenuItem>
                                                        <MenuItem value="last1Year"> Last 12 Month </MenuItem>
                                                        <MenuItem value="Custom"> Custom Date</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={2.3}>
                                            <MDBox mb={4} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="quotationStatus">Quotation Status</InputLabel>
                                                    <Select
                                                        labelId="quotationStatus-select-label"
                                                        id="quotationStatus-select"
                                                        style={{ height: "38.11px" }}
                                                        label="Quotation Status"
                                                        value={values.quotationStatus}
                                                        onChange={(e) => setValues({ ...values, quotationStatus: e.target.value })}
                                                    >
                                                        {/* <MenuItem value="All">All</MenuItem> */}
                                                        <MenuItem value="Pending">Pending</MenuItem>
                                                        <MenuItem value="Approved">Approved</MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={2.3}>
                                            <Autocomplete
                                                labelId="contactName-select-label"
                                                id="contactName-select"
                                                options={contact.map(contact => ({
                                                    label: contact.customerName,
                                                    value: contact._id
                                                }))}

                                                onChange={handleContactChange("customerName")}

                                                value={values.customerName}
                                                sx={{
                                                    '& .MuiAutocomplete-inputRoot': {
                                                        height: "38.11px",
                                                    }
                                                }}
                                                renderInput={(params) =>
                                                    <TextField {...params} label="Customer Name" size="medium"
                                                        placeholder="Customer Name"
                                                        className="ress"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            maxLength: 25,   // <-- ⭐ Max 25 characters
                                                        }}
                                                    />}
                                            />
                                        </Grid>


                                        <Grid item xs={12} lg={2.3}>
                                            <TextField
                                                type="text"
                                                label="Search"
                                                variant="outlined"
                                                fullWidth
                                                className='searchButton'
                                                placeholder="Search..."
                                                size="medium"
                                                autoComplete="new-book"
                                                value={values.filterValues}
                                                onChange={handleSearchFilter}
                                                onKeyUp={(e) => {
                                                    if (e.key === "Enter") fetchQuotationReport();
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment  >
                                                            <Button style={{ borderRadius: "3px 0.3rem  0.3rem 0px", background: barColor }} variant="contained" onClick={fetchQuotationReport}>
                                                                <GridSearchIcon color="white" />
                                                            </Button>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                                            <Link to={"/QuotationReport"}>
                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    onClick={ResetData}
                                                    style={{ height: "38.11px" }}
                                                >
                                                    Reset
                                                </MDButton>
                                            </Link>
                                        </Grid>
                                        <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                                            <MDButton
                                                rel="noreferrer"
                                                variant="gradient"
                                                color="success"
                                                fullWidth
                                                onClick={FilterData}
                                                style={{ height: "38.11px" }}
                                            >
                                                Apply
                                            </MDButton>
                                        </Grid>


                                    </Grid>
                                </MDBox>
                            </Grid>
                        </MDBox>
                    )}
                    {/* <CardContent> */}
                    <BTable

                        columns={reportCol}
                        data={rows}
                        selectableRows={false}
                        sortingType={handleSort}
                        sortServer
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                    // fixedHeaderScrollHeight="410px"
                    // fixedHeader={true}

                    />
                    {/* </CardContent> */}
                </Card>

                {showModel &&
                    <Modal
                        open={showModel}
                        onClose={() => setShowModel(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Card sx={style}>
                            <Box>
                                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                                    <HelpIcon style={{ color: "red" }} />
                                </Typography>
                                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                                    Would you like to export this record?
                                </Typography>
                                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                                    <>
                                        <MDButton className="no-button" onClick={() => { setShowModel(false) }} sx={{ width: "64px", textTransform: "capitalize" }}>
                                            No
                                        </MDButton>
                                    </>
                                    &nbsp; &nbsp;
                                    <>
                                        <CSVLink data={tabledata} headers={headers} filename={"Quotation Report (" + (new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })) + ") .csv"}>
                                            <MDButton className="yes-button" onClick={() => { exportSwal() }} sx={{ width: "64px", textTransform: "capitalize" }}>
                                                Yes
                                            </MDButton>

                                        </CSVLink>
                                    </>
                                </Grid>
                            </Box>
                        </Card>
                    </Modal>
                }
            </div>

        </DashboardLayout>
    );
}
export default QuotationReport;
